import React, {useEffect, useRef, useState} from 'react'
import {useSelector} from 'react-redux';
import {getInvoiceTDS} from '../../../helper/Api';
import DataTable from 'react-data-table-component';
import {AddCommasToAmount} from "../../../helper/Utils";
import {useLocation} from "react-router-dom";
import * as moment from 'moment'

const GISList = ({setSelectednvoice, fromDate, toDate, searchStr, dateColumn}) => {
    const {authData} = useSelector((state) => state.authData);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [totalCount, setTotalCount] = useState(0);
    const lastFetchKeyRef = useRef('');
    let {state} = useLocation();
    const [data, setData] = useState(state && state.data ? state.data : []);

    const fetchChallans = async (page = currentPage, perPage = rowsPerPage) => {
        const fetchKey = [fromDate, toDate, searchStr, dateColumn, page, perPage].join('|');
        if (lastFetchKeyRef.current === fetchKey) return;
        lastFetchKeyRef.current = fetchKey;
        try {
            const data = await getInvoiceTDS({
                from_date: fromDate,
                to_date: toDate,
                searchStr,
                dateColumn,
                gis: true,
                limit: perPage,
                offset: page,
            });
            if (data.data.status) {
                setData(data.data.list || []);
                setTotalCount(Number(data.data.total_count) || 0);
            } else {
                setData([]);
                setTotalCount(0);
            }
        } catch (error) {
            lastFetchKeyRef.current = '';
            setData([]);
            setTotalCount(0);
        }
    }

    useEffect(() => {
        setCurrentPage(1);
        fetchChallans(1, rowsPerPage);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fromDate, toDate, searchStr, dateColumn])


    const customStyles = {
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "14px"
            },
        },
    };

    const columns = [
        {
            name: 'Beneficiary\n' +
                'Name',
            selector: (row) => <b>{row.company_name || ''}</b>,
            sortable: true,
            wrap: true,
            width: "200px"
        },
        {
            name: 'Month/Invoice No',
            selector: (row) => <b>{row.invoice_no}</b>,
            wrap: true,
            sortable: true,
            width: "200px",
        },
        {
            name: 'Date',
            selector: (row) => <b>{row.invoice_date}</b>,
            wrap: true,
            sortable: true,
            width: "200px",

        },
        {
            name: 'Approval\n' +
                'Type',
            selector: (row) =>
                <b>{row.payment_type === '1' ? "FULL PAYMENT" : row.payment_type === '2' ? 'PART PAYMENT' : ''}</b>,
            sortable: true,
            width: "250px",
            wrap: true,
        },
        {
            name: 'Voucher No',
            selector: (row) => <b>{row.voucher_no}</b>,
            sortable: true,
            width: "150px",
            right: false
        },
        {
            name: 'Voucher\n' +
                'Date',
            selector: (row) => <b>{row.voucher_date}</b>,
            sortable: true,
            width: "150px",
            right: false
        }, {
            name: 'Transaction\n' +
                'Date',
            selector: (row) =>  <b>{ (row.transaction_date) ? moment(row.transaction_date, 'YYYY-MM-DD H:i:s').format('DD-MM-YYYY') : ''}</b>,
            sortable: true,
            width: "150px",
            right: false
        },
        {
            name: 'Taxable\n' +
                'Amount',
            selector: (row) => <b>{row.taxable_amount || ''}</b>,
            sortable: true,
            width: "150px",
            right: false
        },
        {
            name: 'INVOICE\n' +
                'AMOUNT',
            selector: (row) => <b>{row.payable_amount || ''}</b>,
            sortable: true,
            width: "150px",
            right: false
        }, {
            name: 'INVOICE\n' +
                'Amount\n' +
                'Sanctioned',
            selector: (row) => <b>{row.sanction_amount || ''}</b>,
            sortable: true,
            width: "150px",
            right: false
        }, {
            name: 'GIS Deduction',
            selector: (row) => <b>{row?.gis || ''}</b>,
            sortable: true,
            width: "150px",
            right: false
        },
        {
            name: 'Details',
            width: "200px",
            selector: (row) => row?.invoice ?
                <a href={row?.invoice} target="_blank" rel="noreferrer">Attachment</a> : '',
            sortable: false,
        },
    ];

    const handleChangeRowsPerPage = (newPerPage, page) => {
        setRowsPerPage(newPerPage);
        setCurrentPage(page);
        fetchChallans(page, newPerPage);
    };

    const handleChangePage = (page) => {
        if (page === currentPage) return;
        setCurrentPage(page);
        fetchChallans(page, rowsPerPage);
    };

    const handleSelectedChange = ({selectedRows}) => {
        setSelectednvoice(selectedRows)
    }

    const calculateTotalAmount = (propertyName) => {
        let total = 0;
        data.forEach((row) => {
            const depositAmount = Number(parseFloat(row[propertyName]));
            if (!isNaN(depositAmount)) {
                total += depositAmount;
            }
        });
        return total.toFixed(2);
    };

    const totalInvoiceAmount = calculateTotalAmount('gis');

    const footerRow = {
        isFooter: true,
        selectableRowsSingle: false,
        invoice_no: <b>Total</b>,
        gis: <b>{AddCommasToAmount(totalInvoiceAmount)}</b>,
    };

    // const paginatedData = data.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

    // let updatedData = [];
    // if (paginatedData?.length) {
    //     updatedData = [...paginatedData, footerRow];
    // } else {
    //     updatedData = []
    // }

    return (
        <div>
            <DataTable
                customStyles={customStyles}
                className="dataTables_wrapper"
                selectableRows={authData.user.user_type === 'l1'}
                onSelectedRowsChange={handleSelectedChange}
                columns={columns}
                data={data}
                fixedHeader
                fixedHeaderScrollHeight="600px"
                pagination
                paginationServer
                paginationPerPage={rowsPerPage}
                paginationDefaultPage={currentPage}
                paginationTotalRows={totalCount}
                paginationRowsPerPageOptions={[25, 50, 100]}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                onChangePage={handleChangePage}
            />
        </div>
    )
}

export default GISList
